<template>
    <div data-v-a403a32a class="Panel">
        <div data-v-a403a32a="" class="tip"><span data-v-a403a32a="">绮罗纤缕见肌肤，此时还恨薄情无。</span></div>
        <div data-v-a403a32a="" class="el-card P-Login is-never-shadow">
            <div class="el-card__body">
                <div data-v-1e292622="" class="G-Title"><i data-v-1e292622="" class="el-icon-user-solid"></i><span
                        data-v-1e292622="">用户注册</span></div>
                <div data-v-1e292622="">
                    <form data-v-1e292622="" :model="registered" class="el-form AuthForm">
                        <div data-v-1e292622="" class="el-form-item form-group el-form-item--feedback">
                            <div class="el-form-item__content">
                                <div data-v-1e292622="" class="el-input">
                                    <input type="username" v-model="registered.username" autocomplete="off" placeholder="请输入用户名" class="el-input__inner">
                                </div>
                            </div>
                        </div>
                        <div data-v-1e292622="" class="el-form-item form-group el-form-item--feedback">
                            <div class="el-form-item__content">
                                <div data-v-1e292622="" class="el-input">
                                    <input type="password" v-model="registered.password1" autocomplete="off" placeholder="请输入密码" class="el-input__inner">
                                </div>
                            </div>
                        </div>
                        <div data-v-1e292622="" class="el-form-item form-group el-form-item--feedback">
                            <div class="el-form-item__content">
                                <div data-v-1e292622="" class="el-input">
                                    <input type="password" v-model="registered.password2" autocomplete="off" placeholder="请再次确认密码" class="el-input__inner">
                                </div>
                            </div>
                        </div>
                        <div data-v-1e292622="" class="el-form-item form-group el-form-item--feedback">
                            <div class="el-form-item__content">
                                <div data-v-1e292622="" class="el-input">
                                    <input type="text" v-model="registered.email" autocomplete="off" placeholder="输入正确邮箱，方便找回密码" class="el-input__inner">
                                </div>
                            </div>
                        </div>
                        <div data-v-1e292622="" class="el-form-item form-group el-form-item--feedback">
                            <div class="el-form-item__content"><button @click="registered_submit" data-v-1e292622="" type="button" class="el-button el-button--primary" style="width: 100%;"><span>注册</span></button></div>
                        </div>
                    </form>
                </div>
                <div data-v-1e292622="" class="my-3">* 请记住用户名，便于登陆和找回密码。</div>
                <div data-v-1e292622="" class="my-3">* 请填写真实邮箱，否则无法找回密码。</div>
            </div>
        </div>
    </div>
</template>

<script>
import cookie from 'js-cookie'
export default {
    name: 'login',
    data() {
        return {

            registered:{
                
                username:'',
                password1:'',
                password2:'',
                email:'',

            },

        }
    },
    methods: {
        registered_submit(){

            let form = this.registered

            if(form.username){

                if(this.registered.username.length<2){

                    this.$message({
                        message: '用户名 必须介于 2 - 20 个字符之间。',
                        type: 'error'
                    });

                }else{

                    if(this.registered.password1){

                        if(this.registered.password1.length<6){

                            this.$message({
                                message: '密码 必须介于 6 - 32 个字符之间。',
                                type: 'error'
                            });

                        }else{

                            if(this.registered.password2){

                                if(this.registered.password2.length<6){

                                    this.$message({
                                        message: '确认密码 必须介于 6 - 32 个字符之间。',
                                        type: 'error'
                                    });

                                }else{

                                    if(this.registered.password1===this.registered.password2){

                                        if(this.registered.email){

                                            this.$http.post('/api/registered',{form}).then(res=>{

                                                if(res.data.code===1){

                                                    if(res.data.sessionid){

                                                        cookie.set('sessionid',res.data.sessionid)

                                                        this.$message({
                                                            message: res.data.msg,
                                                            type: 'success',
                                                            onClose:()=>{
                                                                window.location.href='usercenter';
                                                            }
                                                        });

                                                    }
                                                }else{

                                                    this.$message({
                                                        message: res.data.msg,
                                                        type: 'error'
                                                    });

                                                }

                                            })

                                        }else{
                                            this.$message({
                                                message: '请输入邮箱',
                                                type: 'error'
                                            });
                                        }
                                    }else{

                                        this.$message({
                                            message: '两次密码输入不一致',
                                            type: 'error'
                                        });

                                    }
                                }
                            }else{

                                this.$message({
                                    message: '请输入确认密码',
                                    type: 'error'
                                });

                            }
                        }

                    }else{

                        this.$message({
                            message: '请输入密码',
                            type: 'error'
                        });

                    }

                }

            }else{

                this.$message({
                    message: '请输入用户名',
                    type: 'error'
                });
          
            }
            
        }
    },
    mounted() {

        let sessionid = this.$md5('ciisdz@ciisdz')
        //cookie.set('sessionid',sessionid)
        //cookie.remove('sessionid')

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/registered.vue